// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip-module--tooltip--1Go-Z"};